import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api";

// Fetch Form-specific Logs
export const fetchFormLogs = createAsyncThunk(
  "logs/fetchFormLogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/logs/forms", { params });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch form logs"
      );
    }
  }
);

// Fetch System Audit Logs
export const fetchAuditLogs = createAsyncThunk(
  "logs/fetchAuditLogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/logs/audit", { params });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch audit logs"
      );
    }
  }
);

// Fetch Form Categories and Users list for filters
export const fetchFormsList = createAsyncThunk(
  "logs/fetchFormsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/logs/forms-list");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch filter options"
      );
    }
  }
);

const initialState = {
  formLogs: [],
  formLogsPagination: {
    total: 0,
    current_page: 1,
    per_page: 15,
    last_page: 1,
  },
  auditLogs: [],
  auditLogsPagination: {
    total: 0,
    current_page: 1,
    per_page: 15,
    last_page: 1,
  },
  formsList: [],
  usersList: [],
  isLoading: false,
  error: null,
};

const logSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    clearLogsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Form Logs
      .addCase(fetchFormLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFormLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.formLogs = action.payload?.data || [];
        state.formLogsPagination = {
          total: action.payload?.total || 0,
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 15,
          last_page: action.payload?.last_page || 1,
        };
      })
      .addCase(fetchFormLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Audit Logs
      .addCase(fetchAuditLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.auditLogs = action.payload?.data || [];
        state.auditLogsPagination = {
          total: action.payload?.total || 0,
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 15,
          last_page: action.payload?.last_page || 1,
        };
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Forms List & Users
      .addCase(fetchFormsList.fulfilled, (state, action) => {
        state.formsList = action.payload?.forms || [];
        state.usersList = action.payload?.users || [];
      });
  },
});

export const { clearLogsError } = logSlice.actions;
export default logSlice.reducer;
